import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Container } from "@/components/admin/Container";
import { Header } from "@/components/admin/Header";
import { PlanUsageCard } from "@/components/admin/PlanUsageCard";
import { Searchbar } from "@/components/admin/Searchbar";
import { capitalize } from "@/lib/utils";
import { BillingCard } from "@/modules/settings/billing-card";
import { DeviceManagementCard } from "@/modules/settings/device-management-card";
import { ProfileCard } from "@/modules/settings/profile-card";
import { fullListDevicesQueries } from "@/modules/settings/queries";

export const Route = createFileRoute("/dashboard/settings")({
	loader: async ({ context }) => {
		const queryClient = context.queryClient;

		await queryClient.ensureQueryData(fullListDevicesQueries);
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();

	return (
		<>
			<Header
				breadcrumbs={[
					{
						label: capitalize(t(($) => $.modules.dashboard.title)),
						href: "/dashboard",
					},
					{ label: capitalize(t(($) => $.modules.settings.title)) },
				]}
			>
				<div className="ml-auto flex items-center space-x-4">
					<Searchbar />
				</div>
			</Header>
			<Container className="mx-auto w-full max-w-6xl space-y-6">
				<div className="flex w-full flex-col gap-4 lg:flex-row">
					<ProfileCard />
					<DeviceManagementCard />
				</div>

				<BillingCard />

				<PlanUsageCard />
			</Container>
		</>
	);
}
